import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-our-features',
  templateUrl: './new-our-features.component.html',
  styleUrls: ['./new-our-features.component.scss']
})
export class NewOurFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
